import axios from 'axios';
import Api from 'libs/api/index';
import AuthService from 'services/Auth';

class SalesTracking extends Api {
  constructor() {
    super('admin/sales_trackings');
  }

  getExcel = params => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/admin/sales_trackings.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default SalesTracking;
